import React, { useState } from "react";
import "./App.css";
import Block from "./components/Block";

function App() {
  const [state, setState] = useState(Array(9).fill(null));
  const [currentTurn, setCurrentTurn] = useState("X");
  const [winner, setWinner] = useState<string | null>(null);

  const checkWinner = (state: (string | null)[]) => {
    const win = [
      [0, 1, 2],
      [3, 4, 5],
      [6, 7, 8],
      [0, 3, 6],
      [1, 4, 7],
      [2, 5, 8],
      [0, 4, 8],
      [2, 4, 6],
    ];
    for (let i = 0; i < win.length; i++) {
      const [a, b, c] = win[i];
      if (state[a] !== null && state[a] === state[b] && state[a] === state[c])
        return true;
    }
    return false;
  };

  const isDraw = !winner && state.every((cell) => cell !== null);

  const handleBlockClick = (index: number) => {
    // Don't allow clicks if game is over or cell is taken
    if (state[index] !== null || winner) return;

    const stateCopy = Array.from(state);
    stateCopy[index] = currentTurn;

    // Check if someone won
    if (checkWinner(stateCopy)) {
      setWinner(currentTurn);
    }

    setCurrentTurn(currentTurn === "X" ? "O" : "X");
    setState(stateCopy);
  };

  const handleReset = () => {
    setState(Array(9).fill(null));
    setCurrentTurn("X");
    setWinner(null);
  };

  return (
    <div className="board">
      <h1>Tic Tac Toe</h1>

      <p className="status">
        {winner
          ? `${winner} won the game!`
          : isDraw
          ? "It's a draw!"
          : `Current Turn: ${currentTurn}`}
      </p>

      <div className="row">
        <Block onClick={() => handleBlockClick(0)} value={state[0]} />
        <Block onClick={() => handleBlockClick(1)} value={state[1]} />
        <Block onClick={() => handleBlockClick(2)} value={state[2]} />
      </div>
      <div className="row">
        <Block onClick={() => handleBlockClick(3)} value={state[3]} />
        <Block onClick={() => handleBlockClick(4)} value={state[4]} />
        <Block onClick={() => handleBlockClick(5)} value={state[5]} />
      </div>
      <div className="row">
        <Block onClick={() => handleBlockClick(6)} value={state[6]} />
        <Block onClick={() => handleBlockClick(7)} value={state[7]} />
        <Block onClick={() => handleBlockClick(8)} value={state[8]} />
      </div>

      <button className="reset-btn" onClick={handleReset}>
        Reset Game
      </button>
    </div>
  );
}

export default App;
